export default __webpack_public_path__ + "static/media/alert.fc2cbb61.svg";